export default __webpack_public_path__ + "static/media/video(1).b34212c7.mp4";